import { render, staticRenderFns } from "./SignOutCallback.vue?vue&type=template&id=3a50aa1d"
import script from "./SignOutCallback.vue?vue&type=script&lang=js"
export * from "./SignOutCallback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports